module.exports = "/_next/static/images/5b58ca2908e16f4728dc7e57dda7e678-nubanker-bizarch@3x.jpg";